// src/pages/Settings.jsx

import React from 'react';

const Settings = () => {
  return (
    <div>
      <h1>Settings</h1>
      <p>Here's where you'll manage your preferences and profile settings.</p>
    </div>
  );
};

export default Settings;